import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import BrandLogo from '../components/BrandLogo';
import '../../assets/css/public-pages.css';

const navBtn = (path, current) =>
  `pp-nav-link${current === path ? ' pp-nav-link--active' : ''}`;

export default function PublicNav() {
  const { pathname } = useLocation();

  return (
    <header className="pp-nav">
      <Link to="/home" className="pp-nav-brand">
        <BrandLogo size={32} />
        NextFollowUp
      </Link>
      <nav className="pp-nav-links">
        <Link to="/home" className={navBtn('/home', pathname)}>
          Product
        </Link>
        <Link to="/contact-sales" className={navBtn('/contact-sales', pathname)}>
          Contact sales
        </Link>
        <Link to="/login" className="pp-nav-cta">
          Sign in
        </Link>
      </nav>
    </header>
  );
}
